import { ModalContext } from "app/app";
import { Icon } from "components/lib";
import { Fragment, useContext } from "react";
import styles from "./styles.module.scss";

export function Warning() {
  const { modal, setModal } = useContext(ModalContext);

  return (
    <Fragment>
      {modal.name === "warning" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.image}>
              <Icon image="alert-circle" size={40} color="#fcba03" />
            </div>
            <div className={styles.title}>{modal.data.title}</div>
            <div className={styles.description}>{modal.data.description}</div>
            {modal.data.description2 && (
              <div className={styles.description}>
                {modal.data.description2}
              </div>
            )}
            <div className={styles.footer}>
              <div className={styles.buttons}>
                <button className={styles.cancel} onClick={() => setModal("")}>
                  {modal.data.buttonLabel}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
